import { Spoller, initIntersectionObserver } from "@plugins";

const accordionsWrap = document.querySelector(".js-faq-section-accordions-init");

if (accordionsWrap) {
    initIntersectionObserver(accordionsWrap, initFaqSectionAccordions);
}

function initFaqSectionAccordions() {
    new Spoller(".js-faq-section-accordion", {
        duration: 500,
        selectorToggleBtn: ".js-accordion-toggler",
        selectorContent: ".js-accordion-body",
        makeToggleBtnActive: false,
    });
}
